"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var constants_1 = require("../../../constants");

var Mirador_1 = __importDefault(require("../../Mirador"));

var Base_1 = __importDefault(require("../Base"));

require("./style.scss");
/**
 * Mirador layout Moment.
 */


var MiradorMoment = function MiradorMoment(props) {
  var config = props.config;
  return (// eslint-disable-next-line react/jsx-props-no-spreading
    react_1.default.createElement(Base_1.default, __assign({}, props), react_1.default.createElement(Mirador_1.default, {
      config: config
    }))
  );
};

MiradorMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Configurations to pass through to the `Mirador` component. */
  // eslint-disable-next-line react/forbid-prop-types
  config: prop_types_1.default.object,

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: prop_types_1.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string
};
MiradorMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  color: {
    background: 'gray',
    text: 'white'
  },
  config: undefined,
  layout: constants_1.MomentLayout.Mirador,
  type: constants_1.MomentType.Mirador
});
exports.default = MiradorMoment;